import { Card, CardBody, CardHeader, Row, Col } from 'reactstrap'
import CmsFeaturedMerchantBioService from 'domains/cms-merchant/services/bio-service'
import PropTypes from 'prop-types'
import React from 'react'

const propTypes = {
  merchant: PropTypes.shape({
    merchant: PropTypes.shape({
      id       : PropTypes.number,
      name     : PropTypes.string,
      username : PropTypes.string,
      url_key  : PropTypes.string
    }),
    bio            : PropTypes.string,
    hero_image_url : PropTypes.string,
    hero_video_url : PropTypes.string
  })
}

const defaultProps = {
  merchant: {
    merchant: {
      id       : 0,
      name     : 'Merchant Name',
      username : '',
      url_key  : ''
    },
    bio            : 'Bio',
    hero_image_url : '',
    hero_video_url : ''
  }
}

/**
 * Layout to preview CMS Featured Merchant in create-and-edit page
 */

const CmsMerchantPreviewSection = ({
  merchant
}) => (
  <Card>
    <CardHeader>
      <h2>PREVIEW</h2>
    </CardHeader>
    <CardBody>
      <Row>
        <Col lg='12' style={{ backgroundColor: 'gray' }}>
          <h3 className='text-center'>Header</h3>
        </Col>
      </Row>
      <Row className='pt-4'>
        <Col lg='6' className='p-0' style={{ minHeight: '150px', backgroundColor: 'aqua', textAlign: 'center' }}>
          {
            merchant.hero_image_url ?
              <img src={ `${merchant.hero_image_url}` }  style={{ width: '100%' }} alt=''/>
              :
              <h3 className='text-center' style={{ paddingTop: '55px' }}>Cover Image</h3>
          }
        </Col>
        <Col lg='6'>
          <Row className='ml-2' style={{ height: '20px' }}>
            {
              <h3 className='text-center'>{ `${merchant.merchant.name}` }</h3>
            }
          </Row>
          {
            <Row className='mt-2 ml-2' style={{ height: '85px' }}>
              <p>{ CmsFeaturedMerchantBioService.format(merchant.bio) }</p>
            </Row>
          }

        </Col>
      </Row>
      <Row className='mt-4'>
        <Col lg='4' style={{ height: '450px', backgroundColor: '#808080b8' }}>
          <h3 className='text-center' style={{ paddingTop: '225px' }}>Product Filter</h3>
        </Col>
        <Col lg='8' style={{ height: '450px', backgroundColor: '#80808082' }}>
          <h3 className='text-center' style={{ paddingTop: '225px' }}>Product List</h3>
        </Col>
      </Row>

      <Row className='mt-4'>
        <Col lg='12' style={{ height: '30px', backgroundColor: 'gray' }}>
          <h3 className='text-center'>Footer</h3>
        </Col>
      </Row>
    </CardBody>
  </Card>
)

CmsMerchantPreviewSection.propTypes    = propTypes
CmsMerchantPreviewSection.defaultProps = defaultProps

export default CmsMerchantPreviewSection
